import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggleButton"];
  static values = {
    expandLabel:   { type: String, default: "Expand All" },
    collapseLabel: { type: String, default: "Collapse All" },
  };

  connect() {
    this.sections = new Set();

    this.refreshSections();
    this.updateButton();

    this._onConnected    = (e) => this._addSection(e.target);
    this._onDisconnected = (e) => this._removeSection(e.target);
    this._onState        = ()   => this.updateButton();

    this.element.addEventListener("collapsable-section:connected", this._onConnected);
    this.element.addEventListener("collapsable-section:disconnected", this._onDisconnected);
    this.element.addEventListener("collapsable-section:state", this._onState);
  }

  disconnect() {
    this.element.removeEventListener("collapsable-section:connected", this._onConnected);
    this.element.removeEventListener("collapsable-section:disconnected", this._onDisconnected);
    this.element.removeEventListener("collapsable-section:state", this._onState);
  }

  refreshSections() {
    const found = this.element.querySelectorAll('[data-controller~="collapsable-section"]');
    this.sections = new Set(found);
  }

  _addSection(el) {
    if (el && el.matches?.('[data-controller~="collapsable-section"]')) {
      this.sections.add(el);
      this.updateButton();
    }
  }

  _removeSection(el) {
    if (el) {
      this.sections.delete(el);
      this.updateButton();
    }
  }

  allExpanded() {
    const arr = Array.from(this.sections);
    if (arr.length === 0) return false;
    return arr.every((sec) => (sec.dataset.collapsableSectionExpandedValue ?? "true") === "true");
  }

  toggleAll() {
    const expand = !this.allExpanded();
    const evt = expand ? "collapsable-section:expand" : "collapsable-section:collapse";

    this.sections.forEach((sec) => {
      sec.dispatchEvent(new CustomEvent(evt, { bubbles: false }));
    });

    this.updateButtonLabel(expand ? this.collapseLabelValue : this.expandLabelValue);
  }

  updateButton() {
    this.updateButtonLabel(this.allExpanded() ? this.collapseLabelValue : this.expandLabelValue);
  }

  updateButtonLabel(text) {
    if (this.hasToggleButtonTarget && this.toggleButtonTarget.textContent !== text) {
      this.toggleButtonTarget.textContent = text;
    }
  }
}
